import { faCheckSquare } from "@fortawesome/pro-solid-svg-icons/faCheckSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Checked checkbox button icon.
 * @returns Icon.
 */
const CheckedIcon = () => (
    <FontAwesomeIcon aria-label="checked-icon" fixedWidth={true} icon={faCheckSquare} size="lg" />
);

export default CheckedIcon;
